"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activateMOOMOOMember = activateMOOMOOMember;
exports.addActivity = addActivity;
exports.changeMOOMOOMemberPassword = changeMOOMOOMemberPassword;
exports.changePasskitPoint = changePasskitPoint;
exports.createMOOMOOMember = createMOOMOOMember;
exports.deactivateMOOMOOMember = deactivateMOOMOOMember;
exports.deleteMOOMOOMember = deleteMOOMOOMember;
exports.editMOOMOOMember = editMOOMOOMember;
exports.editPasskitPoint = editPasskitPoint;
exports.getMOOMOOMember = getMOOMOOMember;
exports.getMOOMOOMembers = getMOOMOOMembers;
exports.getPasskitPoint = getPasskitPoint;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function getMOOMOOMembers(params) {
  return (0, _request.default)({
    url: '/api/v1/moomoomembers',
    method: 'get',
    params
  });
}
function getMOOMOOMember(id) {
  return (0, _request.default)({
    url: `/api/v1/moomoomembers/${id}`,
    method: 'get'
  });
}
function createMOOMOOMember(data) {
  return (0, _request.default)({
    url: `/api/v1/moomoomembers`,
    method: 'post',
    data
  });
}
function editMOOMOOMember(data) {
  return (0, _request.default)({
    url: `/api/v1/moomoomembers/${data.id}`,
    method: 'put',
    data
  });
}
function getPasskitPoint(id) {
  return (0, _request.default)({
    url: `/api/v1/moomoomembers/passkitpoint/${id}`,
    method: 'get'
  });
}
function editPasskitPoint(data) {
  return (0, _request.default)({
    url: `/api/v1/moomoomembers/passkitpoint/${data.id}`,
    method: 'put',
    data
  });
}
function addActivity(data) {
  return (0, _request.default)({
    url: `/api/v1/moomoomembers/passkitactivity/${data.id}`,
    method: 'post',
    data
  });
}
function changePasskitPoint(data) {
  return (0, _request.default)({
    url: `/api/v1/moomoomembers/passkitpoint`,
    method: 'put',
    data
  });
}
function changeMOOMOOMemberPassword(data) {
  return (0, _request.default)({
    url: `/api/v1/moomoomembers/password`,
    method: 'put',
    data
  });
}
function deleteMOOMOOMember(id) {
  return (0, _request.default)({
    url: `/api/v1/moomoomembers/${id}`,
    method: 'delete'
  });
}
function activateMOOMOOMember(uuid) {
  return (0, _request.default)({
    url: `/api/v1/moomoomembers/activate`,
    method: 'post',
    data: {
      id: uuid
    }
  });
}
function deactivateMOOMOOMember(uuid) {
  return (0, _request.default)({
    url: `/api/v1/moomoomembers/deactivate`,
    method: 'post',
    data: {
      id: uuid
    }
  });
}